import styled from 'styled-components';
import { device } from 'commons';

export const Main = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 32px 48px 8px;
  overflow-y: auto;
  overflow-x: hidden;

  @media (max-width: ${device.tablet}px) {
    padding: 32px 28px 8px;
  }
`;

export const TextWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const FilterWrapper = styled.div`
  @media (min-width: ${device.desktopSmall}px) {
    max-width: 320px;
  }
`;
